import React from 'react'
import { Link } from 'react-router-dom'
import { I18n } from 'react-i18next'

import AluKHeader from './AluKHeader'
import regions from '../config/regions.json'
import homePic from '../assets/images/home-handle-picture.jpg'
import './RegionPicker.css'

// This is a fallback component. It should not be used as Alu K
// directly points at routes with regions
const RegionPicker = () => (
  <I18n>
    {(t, { i18n }) => [
      <AluKHeader key='aluk-header' />,
      <img src={homePic} alt='Alu K' key='splashImage' className='splash' />,
      <div className='region-picker' key='regions'>
        <p>{t('regionPicker.chooseArea')}</p>
        <div className='continents'>
          {regions.map(({ continent, countries }) => (
            <div className='continent' key={continent}>
              <h2>{continent}</h2>
              <ul>
                {countries.map(country => (
                  <li key={country.id}>
                    <Link
                      to={'/' + country.id}
                      onClick={() => this.setRegion(country)}
                    >
                      {country.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    ]}
  </I18n>
)

export default RegionPicker



// WEBPACK FOOTER //
// ./src/components/RegionPicker.js